import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../balance';
export function fetchBalance() {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_BALANCE
            },
            _a[CALL_API] = {
                endpoint: "/api/account/balance",
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_BALANCE,
                    ActionTypes.FAILURE_FETCH_BALANCE
                ]
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/balance.js